@if (!cellRenderer) {
  @if (value) {
    {{ value }}
  }
  @else {
    <span class="text-slate-300">-</span>
  }
}
